<div class="tw-mb-4 tw-flex">
    <span class="step tw-text-red-500">{{ step }}</span>
    <h4 class="tw-inline-block tw-text-red-500 tw-ml-2 tw-mt-0">
        {{ title }}
    </h4>
</div>
